export enum SettingsOption {
    CERERE_STATUS = 'Status Cerere',
    CERERE_PRIORITY = 'Prioritate Cerere',
    CERERE_TYPE = 'Tipuri Cereri',
    ZILE_LIBERE = 'Zile libere',
    LOCATII = 'Locații',
    MODULE = 'Module',
    MODULE_TIPURI_PROGRAM = 'Module Tipuri Program',
    MODULE_TIPURI_PROGRAM_ACTIVE = 'Module Tipuri Program Active',
    MODULE_LOCATII_ACTIVE = 'Module Locații Active',
    DOCUMENT_CATEGORY = 'Categorii Documente',
    DOCUMENT_TYPE = 'Tipuri Documente',
    OPERATORI = 'Operatori',
}

export enum AdminSettings {
    CONFIGURARI = 'Configurări',
    TYPE_IMAGE_DIMENSIONS = 'Dimensiuni Tip Imagini',
    CRONS = 'Cron-uri',
}
